module.exports = __webpack_public_path__ + "static/valentina-locatelli-130318-unsplash-e31ad106310875029169285aad7e00e7.jpg";